import { render, staticRenderFns } from "./liveIntroduction.vue?vue&type=template&id=1d3c7115&scoped=true&"
import script from "./liveIntroduction.vue?vue&type=script&lang=js&"
export * from "./liveIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./liveIntroduction.vue?vue&type=style&index=0&id=1d3c7115&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c7115",
  null
  
)

export default component.exports